import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useBlogNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const BLOG_STATE_KEY = 'blogNavigationState';

    const saveBlogState = useCallback((state) => {
        try {
            const blogState = {
                currentPage: state.currentPage,
                searchTerm: state.searchTerm,
                sortOrder: state.sortOrder,
                selectedCategory: state.selectedCategory,
                scrollPosition: window.pageYOffset,
                timestamp: Date.now()
            };
            sessionStorage.setItem(BLOG_STATE_KEY, JSON.stringify(blogState));
        } catch (error) {
            console.warn('Erreur sauvegarde état:', error);
        }
    }, []);

    const navigateToArticle = useCallback((slug, currentState) => {
        saveBlogState(currentState);
        navigate(`/blog/${slug}`);
    }, [navigate, saveBlogState]);

    const navigateBackToBlog = useCallback(() => {
        try {
            const savedState = sessionStorage.getItem(BLOG_STATE_KEY);
            if (savedState) {
                const blogState = JSON.parse(savedState);
                const params = new URLSearchParams();
                
                if (blogState.currentPage > 1) params.set('page', blogState.currentPage.toString());
                if (blogState.searchTerm) params.set('search', blogState.searchTerm);
                if (blogState.sortOrder !== 'DateEnvoi:desc') params.set('sort', blogState.sortOrder);
                if (blogState.selectedCategory !== 'toutes') params.set('category', blogState.selectedCategory);
                
                const queryString = params.toString();
                const blogUrl = queryString ? `/blog?${queryString}` : '/blog';
                
                navigate(blogUrl, { state: { restoreState: blogState, shouldRestoreScroll: true } });
                sessionStorage.removeItem(BLOG_STATE_KEY);
            } else {
                navigate('/blog');
            }
        } catch (error) {
            navigate('/blog');
        }
    }, [navigate]);

    const isComingFromArticle = useCallback(() => {
        return location.state?.restoreState !== undefined;
    }, [location.state]);

    return { navigateToArticle, navigateBackToBlog, isComingFromArticle };
};